import { createSlice } from "@reduxjs/toolkit";
import {
  getUserLocal,
  setTokenLocal,
  setUserLocal,
} from "../../utils/localStorage.util";

const initialState = {
  v_user_info: getUserLocal(),
  user: [],
  balance: [],
};

//internally using immer lib (can create mutable state)
export const userSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      setUserLocal(action.payload);
      state.v_user_info = action.payload;
    },
    updateToken: (state, action) => {
      setTokenLocal(action.payload);
      state.v_user_info = action.payload;
    },
    updateAllUser: (state, action) => {
      state.user = action.payload;
    },
    updateAllBalance: (state, action) => {
      state.balance = action.payload;
    },
  },
});

// this is for dispatch
export const { updateUser, updateToken, updateAllUser, updateAllBalance } =
  userSlice.actions;

// this is for configureStore
export default userSlice.reducer;
